import { FormItem } from "../interfaces/FormItem.interface";

/**
 * [Pure]
 * @param initial 
 * @param item 
 */
export function requiredReducer(initial: boolean, item: FormItem): boolean {
    if (!initial) return false;                                                         // If anything else is invalid return false.
    let { visible, required, valid, items } = item;                                     // Get properties from item.
    if (!visible) return true;                                                          // If not visible, item is valid.
    if (required && !valid) return false;                                               // If required and invalid, return false.
    if (visible && items && items.length) return items.reduce(requiredReducer, true);   // If visible and has children, recurse on children.
    return true;                                                                        // If nothing else exits, return true (visible && required && valid).
}
